module.exports = __webpack_public_path__ + "static/media/Item_Weapon_QBZ95_C.6ff4e306.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/item/Weapon/Main/Item_Weapon_QBZ95_C.png
// module id = ./src/assets/item/Weapon/Main/Item_Weapon_QBZ95_C.png
// module chunks = 0